var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              page: _vm.page,
              data: _vm.tableData,
              "table-loading": _vm.tableLoading,
              option: _vm.tableOption,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "search-change": _vm.searchChange,
              "refresh-change": _vm.refreshChange,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "row-save": _vm.handleSave,
              "row-del": _vm.rowDel,
            },
            scopedSlots: _vm._u([
              {
                key: "menuBtn",
                fn: function (scope) {
                  return [
                    _vm.permissions.act_model_manage
                      ? _c(
                          "el-dropdown-item",
                          {
                            attrs: { divided: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleView(scope.row, scope.index)
                              },
                            },
                          },
                          [_vm._v("模型图\n        ")]
                        )
                      : _vm._e(),
                    _vm.permissions.act_model_manage
                      ? _c(
                          "el-dropdown-item",
                          {
                            attrs: { divided: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleDeploy(scope.row, scope.index)
                              },
                            },
                          },
                          [_vm._v("部署\n        ")]
                        )
                      : _vm._e(),
                    _vm.permissions.act_model_manage
                      ? _c(
                          "el-dropdown-item",
                          {
                            attrs: { divided: "" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.handleDel(scope.row, scope.index)
                              },
                            },
                          },
                          [_vm._v("删除\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }